export default {
  session_id: null,
  browser_fingerprint: null,
  retailer_name: null,
  event_type: null,
  event_value: null,
  error_reason: null,
  environment: null,
  event_ts: null,
  tag: 'noflake.returns_fe',
  ingestion_timestamp: null,
  time_zone: null,
  locale: null,
  order_number: null,
  login_email: null,
  return_override_code: null,
  phone: null,
  zip: null,
  is_gift: null,
  billing_street_1: null,
  billing_street_2: null,
  billing_city: null,
  billing_state: null,
  billing_zip: null,
  billing_country: null,
  shipping_street_1: null,
  shipping_street_2: null,
  shipping_city: null,
  shipping_state: null,
  shipping_zip: null,
  shipping_country: null,
  return_reasons_displayed: [],
  nested_return_reasons_displayed: [],
  num_eligible_items: null,
  num_ineligibile_items: null,
  return_methods_displayed: [],
  return_method_selected: null,
  carrier: null,
  confirmation_email: null,
  return_reason_selected_id: null,
  return_reason_selected_name: null,
  nested_return_reason_selected_id: null,
  nested_return_reason_selected_name: null,
  return_options_displayed: [],
  return_options_api_type: null,
  return_option_selected: null,
  zip_displayed: null,
  store_locations_displayed: [],
  store_location_selected: null,
  store_location_selected_index: null,
  store_locations_sorted_by: null,
  store_locations_sorts_displayed: [],
};
